import { RelatorioDespesaItem } from "features/relatorios/typings";
import * as _ from "lodash";

export function getContaCategoriaText(
  contasCategoria: RelatorioDespesaItem["contasCategorias"]
) {
  const uniqueBreadcrumbs = _.uniq(contasCategoria.map((c) => c.breadcrumb));

  if (uniqueBreadcrumbs.length > 1) {
    return "Diversas";
  }

  const categoria = contasCategoria.find(
    (c) => c.breadcrumb === uniqueBreadcrumbs[0]
  );

  return categoria ? `${categoria.breadcrumb} ${categoria.nome}` : "--";
}
